export default __webpack_public_path__ + "static/media/phone.c61acc0e.svg";